import type { ReceiverIdentityAdapter } from "~produce/production/helpers/continuationAdapter";

import { resolveNavSlotPath } from "~/components/mobile/bottomNav/mobileBottomNav";
import MATERIAL_NAMESPACES from "~mobile/material/helpers/materialNavNamespaces";

export const MATERIAL_RECEIVING_TARGET_KIND = "materialReceiving";

export const MATERIAL_RECEIVING_RAIL_ID = "receive";

const isMaterialNamespace = (value: string): boolean => MATERIAL_NAMESPACES.some((namespace) => namespace === value);

const materialReceivingReceiverIdentityAdapter: ReceiverIdentityAdapter = {
	buildCleanPath: (target) =>
		target.targetKind === MATERIAL_RECEIVING_TARGET_KIND && isMaterialNamespace(target.targetId)
			? resolveNavSlotPath(target.targetId, MATERIAL_RECEIVING_RAIL_ID)
			: "",
	matchesRoute: (pathname) => {
		const namespace = MATERIAL_NAMESPACES.find(
			(candidate) => pathname === resolveNavSlotPath(candidate, MATERIAL_RECEIVING_RAIL_ID)
		);
		return namespace ? { targetId: namespace, targetKind: MATERIAL_RECEIVING_TARGET_KIND } : null;
	}
};

export default materialReceivingReceiverIdentityAdapter;
